import { useSession } from 'next-auth/client';

type UseAuthHookResult = {
  isLoggedIn: boolean;
  isLoggedOut: boolean;
  loading: boolean;
};

export const useAuth = (): UseAuthHookResult => {
  const [session, loading] = useSession();

  const isLoggedIn = !loading && Boolean(session?.accessToken);
  const isLoggedOut = !loading && !isLoggedIn;

  return { isLoggedIn, isLoggedOut, loading };
};
